// extracted by mini-css-extract-plugin
export default {"root":"XsellHosting-root_nF0XB","container":"XsellHosting-container_Ue7K9","priceContainer":"XsellHosting-priceContainer_JHLdp","products":"XsellHosting-products_Fw90X"};